import React, { Component } from "react";
import BannerPrincipal from "../Images/BannerPrincipal.png";

const FALLBACK_ROLES = ["Gameplay Programmer", "Front-End Developer"];

class Hero extends Component {
  constructor(props) {
    super(props);
    this.state = { roleIdx: 0, displayText: "", isDeleting: false };
    this.typeNext = this.typeNext.bind(this);
  }

  componentDidMount() {
    this._typeTimer = setTimeout(this.typeNext, 500);
  }

  componentDidUpdate(prevProps) {
    const prev = prevProps.resumeBasicInfo?.ui?.hero_roles?.[0];
    const curr = this.props.resumeBasicInfo?.ui?.hero_roles?.[0];
    if (prev && curr && prev !== curr) {
      clearTimeout(this._typeTimer);
      this.setState({ roleIdx: 0, displayText: "", isDeleting: false }, () => {
        this._typeTimer = setTimeout(this.typeNext, 300);
      });
    }
  }

  componentWillUnmount() {
    clearTimeout(this._typeTimer);
  }

  typeNext() {
    const roles = this.props.resumeBasicInfo?.ui?.hero_roles || FALLBACK_ROLES;
    const { roleIdx, displayText, isDeleting } = this.state;
    const full = roles[roleIdx];

    if (!isDeleting) {
      const next = full.slice(0, displayText.length + 1);
      this.setState({ displayText: next });
      if (next === full) {
        this._typeTimer = setTimeout(
          () => this.setState({ isDeleting: true }, this.typeNext),
          1600
        );
      } else {
        this._typeTimer = setTimeout(this.typeNext, 75);
      }
    } else {
      const next = displayText.slice(0, -1);
      this.setState({ displayText: next });
      if (next === "") {
        this.setState(
          { roleIdx: (roleIdx + 1) % roles.length, isDeleting: false },
          () => { this._typeTimer = setTimeout(this.typeNext, 380); }
        );
      } else {
        this._typeTimer = setTimeout(this.typeNext, 40);
      }
    }
  }

  render() {
    const { displayText } = this.state;
    const ui = this.props.resumeBasicInfo?.ui || {};

    return (
      <section id="hero">
        <div className="hero-left">
          <p className="eyebrow">{ui.hero_eyebrow || "Game Developer"}</p>
          <h1 className="hero-name">
            JARED
            <span className="ghost">FLORES.</span>
          </h1>
          <p className="hero-sub">
            <span className="role-ticker">
              {displayText}<span className="tw-cursor"></span>
            </span>
          </p>
          <p
            className="hero-desc"
            dangerouslySetInnerHTML={{
              __html: ui.hero_desc || "Specialized in <strong>gameplay</strong> and <strong>Unity development.</strong> 5+ years building video games — from indie projects to <strong>Steam releases.</strong>",
            }}
          />
          <div className="hero-ctas">
            <a href="#projects" className="btn btn-gold">
              {ui.hero_cta1 || "View Projects"}
            </a>
            <a href="#about" className="btn btn-ghost">
              {ui.hero_cta2 || "About Me"}
            </a>
          </div>
          <div className="scroll-down">
            <div className="scroll-line"></div>
            {ui.hero_scroll || "Scroll"}
          </div>
        </div>

        <div className="hero-right">
          <div className="hero-photo-glow"></div>
          <img
            src={BannerPrincipal}
            alt="Jared Flores"
            className="hero-photo"
          />
        </div>
      </section>
    );
  }
}

export default Hero;
